import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const Nav = ({ isBurger }) => {
  return (
    <div
      className={
        isBurger
          ? "navigation-container  burger-active"
          : "navigation-container"
      }
    >
      <ul className="navigation-content nav-text">
        <li>
          <NavLink
            to="/"
            className={(nav) => (nav.isActive ? "nav-active" : " ")}
          >
            {" "}
            <span>00</span> Home
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/destination"
            className={(nav) => (nav.isActive ? "nav-active" : " ")}
          >
            {" "}
            <span>01</span> Destination
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/crew"
            className={(nav) => (nav.isActive ? "nav-active" : " ")}
          >
            {" "}
            <span>02 </span>Crew
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/technology"
            className={(nav) => (nav.isActive ? "nav-active" : " ")}
          >
            {" "}
            <span>03</span> Technology
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default Nav;
